<template>
  <div id="app" style="height: 100vh">
    <v-container fluid fill-height>
      <v-row>
        <v-col cols="12">
          <div v-if="showDiv1" :class="{ fade: showDiv1 }">          
            <v-row>
                <v-col cols="12" class="text-center pb-0" >
                    <p class="color_subtitle">ACCESOS AL SISTEMA  </p>
                </v-col>     
            </v-row>
          </div>
          <div v-else :class="{ fadeinverse: !showDiv1 }">
            <mensajeSistema />
            <v-row>
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-card dark class="rounded-xl color_main" max-width="450px">
                  
                  <v-card-text>
                    <v-row>
                      <!--
                      <v-col cols="12" class="d-flex justify-center">
                        <v-img max-width="200px" max-height="100px"
                          src="@/assets/logo_empresa.jpg" class="img"/>
                      </v-col>
                    -->                      
                      <v-col cols="12" class="text-center pb-0">
                        <p class="color_subtitle">ACCESO AL SISTEMA</p>
                      </v-col> 
                    
                      <v-col cols="12" class="pb-0">
                        <v-text-field v-model="dato.xu" label="Usuario" type="text"
                          dark dense outlined hide-details autocomplete="off" autofocus
                          @keydown.enter.prevent="formEnter('password')" ref="usuario">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" class="pb-0">
                        <v-text-field v-model="dato.xp"  label="Contraseña"  ref="password"
                          :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"  :type="showpass ? 'text' : 'password'"
                          dark  dense hide-details outlined autocomplete="off"
                          @click:append="showpass = !showpass" v-on:keydown.enter.prevent="validarLogin">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" class="pb-0">
                        <v-hover v-slot="{ hover }">
                          <v-btn class="btn_block_style2" :elevation="hover ? 12 : 4" dark block @click="validarLogin"> Iniciar Sesión</v-btn>
                        </v-hover>
                      </v-col>

                      <!-- FUNCIONALIDAD NUEVO INGRESO OPCIONAL 
                      <v-col cols="12" class="pb-0" >
                        <v-hover>
                          <template v-slot="{ hover }">
                              <v-btn class="btn_block_style2" :elevation="hover ? 12 : 4" tile dark block
                                  @click="eventIngreso">NUEVO INGRESO</v-btn>
                          </template>
                      </v-hover> 
                    </v-col>  
                      -->                

                      <v-col cols="12" class="pb-0">
                        <v-hover v-slot="{ hover }">
                          <v-btn class="btn_block_style2" :elevation="hover ? 12 : 4" dark block  @click="linkKw()" > Volver</v-btn>
                        </v-hover>
                      </v-col>
                                         
                      <v-hover v-slot="{ hover }">
                        <v-col cols="12" class="d-flex justify-center">
                          <v-btn text :color="hover ? '#ffcc00' : 'white'" @click="forgetPassword" >¿Olvidaste tu contraseña? </v-btn>
                        </v-col>
                      </v-hover>

                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <v-row class="pa-0 ma-0 d-flex align-self-end">
        <v-col cols="12">
          <Footer /> 
        </v-col>
        
      </v-row>
      
    </v-container>   

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" 
            @reloadComp="reloadComp" @close="estadoComponente=false" >
    </component>   
       
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import axios from "@/helpers/axios";
import Footer from '@/layouts/login/footer'; 
import RegisterUserComp from './registerUser.vue'    
import RetrieveUserComp from './RetrieveUser.vue'    
export default {
  name: "login",
  components: {
                Footer,  RetrieveUserComp, RegisterUserComp
              },

  data() {
    return {
      showDiv1: false,
      showpass: false,
      dato: { xu: "", xp: "" },

      compName:"",
      estadoComponente:   false,
      parametroComp : [],
    };
  },

  mounted() {
      this.loadMain()
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ...mapActions("login", ["verificarSession"]),
    ////////////////////////////////////////////////////////

    loadMain(){

        let host = window.location.hostname
        let id_empresa = null
        const hostArray = host.split(".");
        host = hostArray[0]  
      
        switch (host) {
          case 'system':
            case 'demo':
            id_empresa = 1         
          break
        
          case 'verasur':
            id_empresa = 4
          break;


          case 'spacio':
            case 'spaciovzla':
              id_empresa = 5
            break        

          default:
            id_empresa = 1
            console.log(`*** Default demo  ***`)
        }
        
        console.log(`Empresa host: ${host}, id_empresa: ${id_empresa}`)
        this.dato.id_empresa = id_empresa
    },
  
    
    limpiarForm() {
      this.dato = { xu: "", xp: "", id_empresa: "" };
      //this.password = ''
    },

    formEnter(elem) {
      this.$refs[elem].focus();
    },
    async validarLogin() {
      try {
        let us = this.dato.xu;
        let pass = this.dato.xp;
        let params = { usuario: this.dato.xu, password: this.dato.xp, id_empresa: this.dato.id_empresa };

        if (!us || !pass)
          return this.setEnviarMens({
            tipo: "W",
            mensaje: "Falta completar los campos.",
            tiempo: null,
          });

          await axios
          .post("/sistema/main/validarLogin", params)
          .then((response) => {
            let datos = response.data;
            
            if (datos.messageT == "S") {
              datos.payload.sistema = "kwsoluciones";
              console.log("datos:", datos)
             this.verificarSession(datos.payload)

            } else {
              this.setEnviarMens({
                tipo: datos.messageT,
                mensaje: datos.message,
                tiempo: null,
              });
            }
          });
        } catch (error) {
        console.log("error:", error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Su usuario o contraseña es incorrecta.",
          tiempo: null,
        });

      }
    },

   


    // funciones de aperturas y cierres de modales para recuperar contraseña
    forgetPassword() {
      this.parametroComp = {evento:"add"} 
      this.compName = "RetrieveUserComp"
      this.estadoComponente = true
      console.log("forgetPassword")
    },

    closePassword() {
      this.modal_password = false;
    },


    eventIngreso() {
          this.parametroComp = {evento:"add"} 
          this.compName = "RegisterUserComp"
          this.estadoComponente = true
      },


      reloadComp(procedencia){
          console.debug(procedencia)                
          // this.loadMain()
          this.estadoComponente=false
      },


      linkKw(){
        window.location.replace('https://www.kwsoluciones.com')
      }
  },
};
</script>

<style scoped>


.color_subtitle {
  color: #01579b;
  text-shadow: -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff,
    1px 1px 1px #fff;
  font-family: "avenir black oblique";
  letter-spacing: 1.14px;
  font-size: 28px;
}

.fade {
  animation: fadeIn 3s;
}

.fadeinverse {
  animation: fadeOut 2s;
}

@keyframes fadeOut {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
/*
.login {
  background: rgba(255, 255, 255, 0.2);
  width: 30%;
} */
/*********responsive para smartphone */
/*@media (max-width: 360px){
        .login{
            width: 100%;
        }
        .conteprueba{
            width: 100%;
        }
    }
    /*******responsive smartphone */
/*@media (max-width: 425px){
        .login{
            width: 100%;
        }
    }
    /******responsive tablet */
/*@media (min-width: 426px) and (max-width: 640px){
        .login{
            width: 80%;
        }
    }
     @media (min-width: 641px) and (max-width: 768px){
        .login{
            width: 80%;
        }
    }*/
</style>
